import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="2025 - present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Frontend Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">Abaris, Delhi, India</h4>
            <p>
              Designing and developing responsive, user-friendly web interfaces for the EdTech platform using React.js, Next.js, and Tailwind CSS. Implemented dynamic pages, integrated APIs for seamless data flow, and enhanced user experience across courses, cart, and checkout functionalities.
            </p>


          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2024 - 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Full-Stack Developer</h3>
            <h4 className="vertical-timeline-element-subtitle">Sekyoor Solutions Private Limited, Noida, India</h4>
            <p>
              Developed responsive web interfaces using React.js and Tailwind CSS, enhancing frontend performance and user experience. Integrated RESTful APIs with Node.js and Express.js to create dynamic, data-driven features, while improving component reusability and reducing code duplication through clean, modular architecture.
            </p>


          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2024 - 2025"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Full-Stack Developer Intern</h3>
            <h4 className="vertical-timeline-element-subtitle">Ducat, Noida, India</h4>
            <p>
              Built responsive MERN stack web applications with RESTful APIs and dynamic UI using React and Tailwind CSS. Gained hands-on experience in frontend, backend, and database integration.
            </p>

          </VerticalTimelineElement>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            date="2023 - 2024"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Growth & Analytics Associate</h3>
            <h4 className="vertical-timeline-element-subtitle">Unacademy, Bangalore, India</h4>
            <p>
              Led data-driven Go-to-Market (GTM) initiatives and regional campaigns, increasing category leads by 20% and revenue by 2.5x.
              Boosted YouTube channel performance by doubling average watch time and improved customer loyalty with NPS rising from 78% to 94%.
              Managed vendor and inventory operations ensuring smooth workflows and consistent supply of quality educational content.
            </p>

          </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;